<template>
  <div id="app">
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand href="./"
        ><img src="@/assets/images/logo.png" alt="Company Name"
      /></b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            v-if="is_authenticated"
            right
            :text="username_display"
          >
            <b-dropdown-item @click="$router.push({ name: 'Profile' })"
              >Profil</b-dropdown-item
            >
            <b-dropdown-item @click="$router.push({ name: 'GeneratedForms' })"
              >Wygenerowane wnioski</b-dropdown-item
            >
            <b-dropdown-item
              @click="logout($event), $router.push({ name: 'Login' })"
              >Wyloguj</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    // return currently authenticate username
    username_display: function() {
      return `Witaj ${this.$store.state.user.display_name}`;
    },
    is_authenticated: function() {
      if (this.$store.state.user.display_name) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // logout user
    logout: function(event) {
      this.$store.dispatch("user_logout");
      event.preventDefault();
    }
  }
};
</script>

<style>
body {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("assets/images/background.jpeg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  -o-background-size: cover;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app nav img {
  height: 75px;
}

.form-group.required.field-switch .field-wrap label:after {
  content: none;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.form-group label > :first-child {
  font-size: large;
  margin-left: 2px;
}
.form-group.required > label {
  display: flex;
  flex-direction: row;
}
.form-group.required > label:after {
  order: -1;
  margin-left: -10px;
}
.vue-form-generator .field-checklist .listbox {
  max-height: none !important;
  border: none !important;
  background-color: #f8f9fa !important;
  box-shadow: none !important;
}
.notices .toast .toast-text {
  word-break: normal !important;
}
</style>
